import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSettings } from '../../contexts/SettingsContext';
import { THEME_BY_ID } from '../../themes';
import './ThemePreviewBanner.css';

/**
 * Banderoll som visas medan ett tema granskas från temalabbet.
 *
 * Renderas globalt (App.js) och inte i adminpanelen, eftersom hela poängen är
 * att kunna gå runt på RIKTIGA sidor i temat — matchsidan, topplistan, veto —
 * och se vad som skaver. Utan banderollen är det lätt att glömma att man är
 * kvar i granskningsläge och tro att sajten är trasig.
 *
 * Läget bor bara i minnet, så en omladdning avslutar det. Banderollen säger
 * det, annars är avslutsknappen det enda synliga sättet ut.
 *
 * @returns {JSX.Element|null} Banderollen, eller null när inget granskas.
 */
export default function ThemePreviewBanner() {
  const { t } = useTranslation();
  const { previewThemeId, setPreviewThemeId } = useSettings();

  if (!previewThemeId) return null;

  const label = THEME_BY_ID[previewThemeId]?.label || previewThemeId;

  return (
    <div className="theme-preview-banner" role="status">
      <span className="theme-preview-banner-text">
        {t('admin.themeLab.previewing', { theme: label })}
      </span>
      <button
        type="button"
        className="theme-preview-banner-exit"
        onClick={() => setPreviewThemeId(null)}
      >
        {t('admin.themeLab.previewExit')}
      </button>
    </div>
  );
}
